import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MilestoneStatusEnum, ServiceContractStatusEnum } from "../../../../../../enum/service.enum";

import { isMilestoneCanceled } from "./utils";

interface MilestoneStatusDisplayProps {
  status: MilestoneStatusEnum;
  contractStatus: ServiceContractStatusEnum;
  showStatus: boolean;
}

export const MilestoneStatusDisplay = ({ status, contractStatus, showStatus }: MilestoneStatusDisplayProps) => {
  const { t: tMilestoneStatus } = useTranslation("goService", { keyPrefix: "milestoneStatus" });

  if (!showStatus) {
    return null;
  }

  const canceled = isMilestoneCanceled(status, contractStatus);
  const displayStatus = canceled ? "canceled" : status;

  return (
    <Typography sx={styles.milestoneStatus(canceled)} component="span">
      {tMilestoneStatus(displayStatus)}
    </Typography>
  );
};

const styles = {
  milestoneStatus: (isCanceled: boolean) => ({
    color: "var(--Success-700, #027A48)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "16px",
    border: "1.5px solid var(--Success-600, #039855)",
    background: "#ECFDF3",
    padding: "4px 12px",
    ...(isCanceled && {
      color: "var(--Error-700, #B42318)",
      border: "1.5px solid var(--Error-600, #F04438)",
      background: "#FEF3F2",
    }),
  }),
};
